import React from 'react'
import Text from '../../atoms/Text'
import { formatCurrency } from '../../../utils/helpers/common'
import BillPaperEffect from '../../../assets/images/bill-paper-bottom.png'

const BillSummary = () => {
  return (
    <div className="flex flex-col gap-4 px-4 py-1">
      <div className="w-full flex flex-row items-center justify-between">
        <Text
          tag={'p'}
          variant={'title'}
          size={'medium'}
          className={'text-text-primary'}
        >
          Bill Summary
        </Text>
      </div>
      <div className="bg-WHITE rounded-4 overflow-hidden">
        <div className="flex flex-col px-4 py-6 gap-4">
          <div className="flex flex-col gap-6">
            <div className="flex flex-row items-center justify-between">
              <Text
                tag={'p'}
                variant={'label'}
                size={'medium'}
                className={'text-text-secondary'}
              >
                Price
              </Text>
              <Text
                tag={'p'}
                variant={'label'}
                size={'medium'}
                bold={'true'}
                className={'text-text-primary'}
              >
                {formatCurrency(999)}
              </Text>
            </div>
            <div className="flex flex-row items-center justify-between">
              <Text
                tag={'p'}
                variant={'label'}
                size={'medium'}
                className={'text-text-secondary'}
              >
                Discount
              </Text>
              <Text
                tag={'p'}
                variant={'label'}
                size={'medium'}
                bold={'true'}
                className={'text-text-success-primary'}
              >
                -{formatCurrency(400)}
              </Text>
            </div>
          </div>
          <div className="w-full bg-border-secondary h-[1px]" />
          <div className="flex flex-row items-center justify-between">
            <Text
              tag={'p'}
              variant={'label'}
              size={'medium'}
              className={'text-text-secondary'}
            >
              Total
            </Text>
            <Text
              tag={'p'}
              variant={'title'}
              size={'medium'}
              className={'text-text-primary'}
            >
              {formatCurrency(599)}
            </Text>
          </div>
        </div>
        <div className="w-full bg-INDIGO-600">
          <img src={BillPaperEffect} className="w-full h-auto" alt="paper" />
          <div className="flex items-center justify-center py-3">
            <Text
              tag={'p'}
              variant={'label'}
              size={'medium'}
              bold={'true'}
              className={'text-WHITE'}
            >
              You saved {formatCurrency(400)}
            </Text>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BillSummary
